var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isShownPromoCode ? _c('div', {
    staticClass: "promo-code-container"
  }, [_c('toggle-panel', {
    attrs: {
      "title": _vm.$t('common.promocode')
    },
    on: {
      "click": _vm.handleClickOnPanel
    },
    model: {
      value: _vm.promoCode.active,
      callback: function callback($$v) {
        _vm.$set(_vm.promoCode, "active", $$v);
      },
      expression: "promoCode.active"
    }
  }, [_c('coupon-icon', {
    attrs: {
      "slot": "icon"
    },
    slot: "icon"
  }), _c('div', {
    staticClass: "promo-code-content",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('div', {
    staticClass: "input-container"
  }, [_c('capusta-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: _vm.promoCodeTokens,
      expression: "promoCodeTokens"
    }],
    attrs: {
      "label": _vm.$t('common.promocode'),
      "placeholder": _vm.$t('promocode.placeholder'),
      "error": !_vm.isValidPromoCode,
      "validation": _vm.validatePromoCode
    },
    model: {
      value: _vm.promoCode.code,
      callback: function callback($$v) {
        _vm.$set(_vm.promoCode, "code", $$v);
      },
      expression: "promoCode.code"
    }
  })], 1), _c('div', {
    staticClass: "input-container input-promo-code-container"
  }, [_vm.isShownDiscountPercent ? _c('capusta-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: _vm.percentTokens,
      expression: "percentTokens"
    }],
    key: "discountPercent",
    attrs: {
      "label": _vm.$t('promocode.discount.label'),
      "placeholder": _vm.displayPlaceholderDiscountPercent,
      "error": !_vm.isValidDiscountPercent,
      "validation": _vm.validateDiscountPercent
    },
    model: {
      value: _vm.promoCode.discountPercent,
      callback: function callback($$v) {
        _vm.$set(_vm.promoCode, "discountPercent", $$v);
      },
      expression: "promoCode.discountPercent"
    }
  }, [_c('div', {
    staticClass: "input-control-button",
    attrs: {
      "slot": "composite"
    },
    on: {
      "click": _vm.onToggleInputType
    },
    slot: "composite"
  }, [_vm._v(" " + _vm._s(_vm.displayDiscountSymbol) + " ")])]) : _c('capusta-input', {
    directives: [{
      name: "mask",
      rawName: "v-mask",
      value: ['####', '# ###', '## ###'],
      expression: "['####', '# ###', '## ###']"
    }],
    key: "discountAmount",
    attrs: {
      "label": _vm.$t('promocode.discount.label'),
      "placeholder": _vm.displayPlaceholderDiscountAmount,
      "error": !_vm.isValidDiscountAmount,
      "validation": _vm.validateDiscountAmount
    },
    model: {
      value: _vm.promoCode.discountAmount,
      callback: function callback($$v) {
        _vm.$set(_vm.promoCode, "discountAmount", $$v);
      },
      expression: "promoCode.discountAmount"
    }
  }, [_c('div', {
    staticClass: "input-control-button",
    attrs: {
      "slot": "composite"
    },
    on: {
      "click": _vm.onToggleInputType
    },
    slot: "composite"
  }, [_vm._v(" " + _vm._s(_vm.displayDiscountSymbol) + " ")])])], 1), _c('div', {
    staticClass: "switcher-container switcher-link-container"
  }, [_c('cs-switcher', {
    attrs: {
      "label": _vm.$t('promocode.apply.to.all.bills')
    },
    model: {
      value: _vm.promoCode.applyToAllBills,
      callback: function callback($$v) {
        _vm.$set(_vm.promoCode, "applyToAllBills", $$v);
      },
      expression: "promoCode.applyToAllBills"
    }
  }), _c('help-link', {
    attrs: {
      "source": "https://help.capusta.space/payment_page/promo_code"
    }
  })], 1), _c('div', {
    staticClass: "button-primary-container"
  }, [_c('cs-button', {
    attrs: {
      "disabled": !_vm.isValid,
      "width": "100%"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.save')) + " ")])], 1)])], 1)], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }